module.exports = __webpack_public_path__ + "static/media/arrow.503ffd58.svg";